import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import SnackbarProvider from "react-simple-snackbar"

import { Boiler } from "./Boiler"
import { EmailQuote } from "./EmailQuote"
import { quoteCheckoutURL } from "../../../../utilities"

import SadFace from "../../../../images/illustrations/sad-face.svg"

export const BoilerSuggestions = ({ quote }) => {
  const [emailQuoteVisible, setEmailQuoteVisibility] = React.useState(false)
  const {
    bathtubs,
    bedrooms,
    showers,
    id,
    postcode,
    propertyType,
    suggestedBoilers,
  } = quote

  return (
    <div className="wrapper-width wrapper-height-small">
      {suggestedBoilers.length > 0 ? (
        <header className="boiler-suggestions-header">
          <h1 className="heading-large">
            {suggestedBoilers.length} recommended boiler
            {suggestedBoilers.length > 1 ? "s" : ""}
          </h1>
          <p className="boiler-suggestions-quote-stats">
            For your {bedrooms} bedroom,{" "}
            {bathtubs ? `${bathtubs} bathtub, ` : ""}
            {showers ? `${showers} shower, ` : ""}
            {propertyType === "bungalow" || propertyType === "apartment"
              ? propertyType
              : propertyType + " home"}{" "}
            in {postcode}
          </p>
          <div className="boiler-suggestions-header-buttons">
            <button
              className="button-primary"
              onClick={() => setEmailQuoteVisibility(true)}
            >
              Email your quote
            </button>
            <Link
              to="/quote"
              className="button-secondary button-with-icon icon-left"
            >
              <span className="button-icon icon-edit"></span>
              <span className="button-with-icon-text">Change answers</span>
            </Link>
            <SnackbarProvider>
              <EmailQuote
                quoteId={id}
                isVisible={emailQuoteVisible}
                dismissFunc={() => setEmailQuoteVisibility(false)}
              />
            </SnackbarProvider>
          </div>
        </header>
      ) : (
        <header className="boiler-suggestions-header boiler-suggestions-header-no-results">
          <SadFace />
          <h1 className="heading-large">0 recommended boilers</h1>
          <div className="boiler-suggestions-no-results-description">
            <p>
              Sorry, we only stock combi and regular boilers for homes with less
              than 6 bedrooms.
            </p>
            <p>
              If you think you're seeing this message by mistake please contact
              us now.
            </p>
          </div>
          <div className="boiler-suggestions-header-no-results-buttons">
            <Link to="/quote" className="button-primary">
              Restart quote
            </Link>
            <Link to="/contact-us" className="button-secondary">
              Contact us
            </Link>
          </div>
        </header>
      )}
      <main className="boiler-suggestions">
        {suggestedBoilers.map((boiler, index) => (
          <Boiler
            contentfulId={boiler.id}
            award={boiler.award}
            label={index === 0 ? true : false}
            key={boiler.id}
            boilerId={boiler.id}
            bullets={boiler.features}
            tagline={boiler.tagline}
            name={boiler.name}
            photo={boiler.photo}
            totalPrice={boiler.price}
            urlBookInstallation={quoteCheckoutURL(id, boiler.id)}
            urlMoreInfo={`/boilers/${boiler.slug}`}
            labourCost={quote.labourCost}
            interestRate={quote.interestRate}
            flueCost={quote.flueCost}
            vat={quote.vat}
          />
        ))}
      </main>
    </div>
  )
}

BoilerSuggestions.propTypes = {
  quote: PropTypes.object.isRequired,
}
